import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-cards',
  templateUrl: './cards.component.html',
  styleUrls: ['./cards.component.scss']
})
export class CardsComponent implements OnInit {
  @Input() vacancies;
  @Input() color;
  @Input() pagination;
  @Input() companyKey;
  @Input() showOpportunity:boolean = false as boolean;

  constructor(
    private route: Router,
    private activeRoute: ActivatedRoute
  ) { }

  ngOnInit() { }

  openVacancy(companyKey, vacancyKey) {
    const url = this.route.createUrlTree([`/${companyKey}/${vacancyKey}`], { queryParamsHandling: 'preserve' });
    window.open(url.toString(), '_blank');
  }
}
